module.exports = __webpack_public_path__ + "img/applepay.e5499e4d.png";